var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCareerdiscovery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21.6223V19.6223C17 18.5614 16.5786 17.544 15.8284 16.7939C15.0783 16.0437 14.0609 15.6223 13 15.6223H5C3.93913 15.6223 2.92172 16.0437 2.17157 16.7939C1.42143 17.544 1 18.5614 1 19.6223V21.6223",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 11.6223C11.2091 11.6223 13 9.83145 13 7.62231C13 5.41318 11.2091 3.62231 9 3.62231C6.79086 3.62231 5 5.41318 5 7.62231C5 9.83145 6.79086 11.6223 9 11.6223Z",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23 21.6223V19.6223C22.9993 18.736 22.7044 17.8751 22.1614 17.1746C21.6184 16.4742 20.8581 15.9739 20 15.7523",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16 3.75232C16.8604 3.97262 17.623 4.47302 18.1676 5.17463C18.7122 5.87624 19.0078 6.73915 19.0078 7.62732C19.0078 8.51549 18.7122 9.3784 18.1676 10.08C17.623 10.7816 16.8604 11.282 16 11.5023",
    stroke: "#787486",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerdiscovery);
export default __webpack_public_path__ + "static/media/careerdiscovery.e01cbffa4ceba49012f5ad869bddb43b.svg";
export { ForwardRef as ReactComponent };